// ---------------------------------------------------------------------------
// Image Gallery Renderer
// ---------------------------------------------------------------------------

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text, url } from "../escape.js";

interface GalleryImage {
  src: string;
  alt?: string;
  caption?: string;
}

interface ImageGalleryProps {
  heading?: string;
  images: GalleryImage[];
  layout?: "grid" | "masonry" | "carousel";
  columns?: number;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as unknown as ImageGalleryProps;

  const images = Array.isArray(p.images) ? p.images : [];
  const columns = Math.max(2, Math.min(4, p.columns ?? 3));

  const headingHtml = p.heading
    ? `<h2 class="ease-gallery-heading">${text(p.heading)}</h2>\n  `
    : "";

  const imagesHtml = images
    .map((img) => {
      const altText = img.alt ?? "";
      const captionHtml = img.caption
        ? `<figcaption>${text(img.caption)}</figcaption>`
        : "";

      return `    <figure class="ease-gallery-item">
      <img src="${url(img.src)}" alt="${attr(altText)}" loading="lazy">
      ${captionHtml}
    </figure>`;
    })
    .join("\n");

  return `<section class="ease-section ease-image-gallery" aria-label="${attr(p.heading ?? "Image gallery")}">
  ${headingHtml}<div class="ease-gallery-grid" style="display: grid; grid-template-columns: repeat(${attr(String(columns))}, 1fr); gap: var(--ease-spacing-md, 1rem);">
${imagesHtml}
  </div>
</section>`;
}

registerRenderer("image-gallery", { render });
